











































































































































































import PointNotation from "@/common/components/atoms/PointNotation.vue";
import TextLabelNewArrivalCount from "@/common/components/atoms/TextLabelNewArrivalCount.vue";

import HeaderMessage from "@/common/components/organisms/header/HeaderMessage.vue";
import TheHeaderBottomNaviForPcLayout from "@/common/components/organisms/header/TheHeaderBottomNaviForPcLayout.vue";
import TheHeaderNaviForSpLayout from "@/common/components/organisms/header/TheHeaderNaviForSpLayout.vue";
import TheHeaderPointNotificationForSpLayout from "@/common/components/organisms/header/TheHeaderPointNotificationForSpLayout.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconLogout from "@/common/components/icons/IconLogout.vue";
import IconLoop from "@/common/components/icons/IconLoop.vue";
import ModalMain from "@/common/components/organisms/ModalMain.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import TheHeaderUserNavi from "@/common/components/organisms/header/TheHeaderUserNavi.vue";
import commons from "@/common/store/modules/commons";
import store from "@/general/store";
import globals from "@/general/store/modules/globals";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SwitchSiteRequest, HeaderInfo } from "@/general/store/models";

import {
  getUserProfileSummary,
  postSwitchSite,
  getHeaderInfo
} from "@/general/store/api";

import { karteUser, karteLogin } from "@/common/assets/js/karte/";
import LocalStorage from "@/general/utils/storage";
import auth from "@/general/store/modules/auth";
import * as Cookies from "js-cookie";
import loginInfo from "@/general/store/modules/loginInfo";
import AuthApi from "@/general/api/authApi";
import SITE_MAP from "@/general/mixins/const/custom/sitemap";

@Component({
  name: "TheHeader",
  components: {
    PointNotation,
    TextLabelNewArrivalCount,
    TheHeaderNaviForSpLayout,
    TheHeaderUserNavi,
    TheHeaderPointNotificationForSpLayout,
    TheHeaderBottomNaviForPcLayout,
    HeaderMessage,
    IconBase,
    IconLogout,
    IconLoop,
    ModalMain,
    ButtonMain
  },
  store: store
})
export default class TheHeader extends Vue {
  @Prop({ default: false }) readonly isWideHeader!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) ssoFlg!: boolean;

  serviceLogoStyle: any = {};
  userInfo = commons.userInfo;
  serviceName = commons.serviceName;
  serviceLogo: string | undefined = "";
  thanksPointUnreadCount = 0;
  whatsNewUnreadCount = 0;
  userImage = "";
  closeHelpPopup = false;
  point = 0;
  headerHeight = 0;
  switchButton: any = {};
  switchButtonSvg = "#ffffff";
  totalUnreadCount = 0;
  switchState = false;
  imageResources: any = {};
  userAdmin: string | null = "0";

  $refs!: {
    lTheHeader: Element;
    pTheHeader: Element;
  };

  get colorCode() {
    if(this.isGroupBudget) {
      return '#fc9014'
    }
    return commons?.colorCode;
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  get grantExclusiveEnabled(): boolean {
    return auth.user?.grant_exclusive_points_enabled;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  getLogo() {
    return this.imageResources["page_logo"];
  }

  initServiceLogoStyle() {
    //#59042対応によりセッション情報からpage_logoを取得するように修正
    //const serviceLogo: any = commons?.OrgPageSpecific?.page_logo;
    //const serviceLogo: any = commons?.OrgPageSpecific?.page_logo;
    const serviceLogo: any = this.imageResources.page_logo;
    this.serviceLogo = this.imageResources.page_logo;
    
    if (serviceLogo && serviceLogo.width) {

      const rem = 16;
      const maxWidth = serviceLogo.width / rem;

      this.serviceLogoStyle = {
        maxWidth: `${maxWidth}rem`
      };
    }
  }

  get isUserAdmin() {
    return this.userAdmin === "1";
  }

  showModal() {
    this.switchState = true;
  }

  handleButtonClick(flag: boolean) {
    if (flag) {
      this.switchState = false;
      this.switchSite();
      return;
    }
    this.switchState = false;
  }

  async switchSite() {
    const redirectUrl = process.env.VUE_APP_ADMIN_DOMAIN + "/incp/csv-download";
    this.logout(redirectUrl);
  }

  initSwitchButtonObject() {
    const headerInfo = commons.headerInfo;
    const pageType = headerInfo.pageType;
    this.switchButton = headerInfo.switch[pageType];
  }

  mouseoverSwitchButton(mouseover = true) {
    const commonPrimary = this.colorCode?.toString();
    const mouseleave = "#ffffff";

    const resultColor: any = {
      mouseover: commonPrimary,
      mouseleave: mouseleave
    };

    const resultIndex: string = mouseover ? "mouseover" : "mouseleave";

    this.switchButtonSvg = resultColor[resultIndex];
  }

  /**
   * SP画面のときにfixedHeaderのスタイルを追加する
   */
  @Watch("switchState")
  get fixedHeader(): any {
    const style = {
      position: "fixed",
      width: "100%",
      zIndex: "10000"
    };
    if (this.switchState) {
      style.zIndex = "999";
    }

    return this.isSp ? style : "";
  }

  get totalPoints() {
    return this.point;
  }

  get iconStyle() {
    const isSpScreenWidth = globals.isLargeBreakpointWidthOfSp;

    if (isSpScreenWidth) {
      return {
        logout: {
          size: 24,
          color: "#000000"
        }
      };
    } else {
      return {
        logout: {
          size: 36,
          color: "#979797"
        }
      };
    }
  }

  get shownHeaderElement() {
    const shownHeaderItem = commons.shownHeaderItem;
    const keyword = /logo|point|searchForm|userMenu|favorite|history|help|switchButton|spNavi|all|logout/;
    if (shownHeaderItem) {
      return shownHeaderItem.some((element: any) => keyword.test(element));
    } else {
      return "all";
    }
  }

  get isExists() {
    return (str: any) => {
      const { shownHeaderItem } = commons.shownHeaderItem;

      const regex = new RegExp(`all|${str}`, "g");

      if (shownHeaderItem) {
        shownHeaderItem.some((element: any) => regex.test(element));
      } else {
        return "all";
      }
    };
  }

  get showPoint(): boolean {
    const USER_ROLES = LocalStorage.getItem("USER_ROLES")
      ? JSON.parse(LocalStorage.getItem("USER_ROLES") as string)
      : [{}];
    const USER_POINTS = LocalStorage.getItem("USER_POINTS")
      ? JSON.parse(LocalStorage.getItem("USER_POINTS") as string)
      : [{}];
    const hasGrantOnlyPoint = USER_POINTS.grant_only_points > 0;
    const isOverManager =
      USER_ROLES.is_master_admin ||
      USER_ROLES.is_group_admin ||
      USER_ROLES.is_manager;
    return (
      (this.isAdminSite && hasGrantOnlyPoint && isOverManager) ||
      !this.isAdminSite
    );
  }

  get shownRightColumn() {
    return "point|searchForm|userMenu";
  }

  get shownTopElement() {
    return "logo|point|searchForm|userMenu";
  }

  mounted() {
    //index.htmlではenvファイルの値を取得できないためTheHeader.vue内でwovnのスクリプトを設定
    const script = document.createElement("script");
    script.src = "https://j.wovn.io/1";
    const wovnioKey = process.env.VUE_APP_WOVNIO_KEY;
    if(wovnioKey){
      script.setAttribute("data-wovnio", wovnioKey);
    }
    script.async = true;
    document.head.appendChild(script);
    
    this.headerHeight = this.getheaderHeight();
    if (!this.isAdminSite) {
      karteUser();
    }

    window.onpageshow = function(event: any) {
      if (event.persisted) {
        window.location.reload();
      }
    };
    window.addEventListener("resize", this.handleResize);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }

  private handleResize() {
    const lTheHeader = this.$refs.lTheHeader.getBoundingClientRect().height;
    const pTheHeader = this.$refs.pTheHeader.getBoundingClientRect().height;
    this.headerHeight = lTheHeader + pTheHeader;
  }

  private getheaderHeight() {
    const lTheHeader = this.$refs.lTheHeader.getBoundingClientRect().height;
    const pTheHeader = this.$refs.pTheHeader.getBoundingClientRect().height;
    const mainHeader = lTheHeader + pTheHeader + 7;
    return mainHeader;
  }

  //Lifecycle hook
  async created() {
    commons.setOrgPageSpecificDataFromLocalStorage();
    commons.getCustomData();
    // commons.userInfoの初期化（同メソッド内下部にも同呼び出しがあるが、初期化が間に合わず他画面でサンクスポイント名称を取得できない箇所があったため呼び出しを実行）
    commons.getUserInfo();
    this.ssoFlg = loginInfo.isSso;
    await this.initSwitchButtonObject();

    await AuthApi.getICSession()
    .then((result) => {
        const ic_session = JSON.parse(result);
        this.imageResources = {
          "page_logo": ic_session.pageLogo,
          "point_logo": ic_session.pointLogo,
          "favicon": ic_session.favicon,
          "avatar": ic_session.avatar
        }
        LocalStorage.setItem("userIsAdmin", ic_session?.isAdmin);
        this.userAdmin = ic_session?.isAdmin;
    })
    .catch(() => {
      this.imageResources = {
          "page_logo": "",
          "point_logo": "",
          "favicon": "",
          "avatar": ""
        }
    });

    await this.initServiceLogoStyle();
    
    const link: any = document.querySelectorAll('link[rel="icon"]')[0];
    link.href = this.imageResources.favicon;

    // TODO get point from session redis
    const userPointsDetails = await getUserProfileSummary();

    LocalStorage.setItem(
      "userPointsDetails",
      JSON.stringify(userPointsDetails)
    );
    await commons.getUserPoints();

    const userDetails = JSON.parse(
      LocalStorage.getItem("userDetails") as string
    );
    this.userImage = this.imageResources.avatar;
    // commons.userInfoの初期化（同メソッド内上部にも同呼び出しがあるが、非同期処理の都合上こちらでも呼び出しを実行）
    commons.getUserInfo();

    const headerInfo: HeaderInfo = await getHeaderInfo();

    this.thanksPointUnreadCount = headerInfo.thanks_msg_noread_cnt;
    this.whatsNewUnreadCount = headerInfo.whatnew_noread_cnt;
    this.totalUnreadCount =
      this.thanksPointUnreadCount + this.whatsNewUnreadCount;
    this.point = headerInfo.point;
  }

  get isAdminSite() {
    return false;
  }

  async logout(redirectUrl: string) {
    karteLogin(false);

    let cookieName = "BSJSESSIONID";
    if (process.env.VUE_APP_SESSION_COOKIE_NAME) {
      cookieName = process.env.VUE_APP_SESSION_COOKIE_NAME;
    }
    let cookieDomain = ".benefit-one.inc";
    if (process.env.VUE_APP_COOKIE_DOMAIN) {
      cookieDomain = process.env.VUE_APP_COOKIE_DOMAIN;
    }
    console.log("delete cookie name." + cookieName);
    //document.cookie = `${cookieName}=;domain=${cookieDomain};path=/;`;
    Cookies.remove(cookieName);
    await fetch(commons.LOGOUT_URL, { method: "POST" })
      .then(() => {
        window.sessionStorage.clear();
        // window.localStorage.clear();
        LocalStorage.removeAll();
        AuthApi.getLogout().catch((e) => {
          console.log(e);
        });
        auth.remove();
        if (this.ssoFlg) {
          // SSOログインの場合は行き止まりログアウトへ遷移
          window.location.href = "/logout/";
        } else {
          const toTopUrl = process.env.VUE_APP_API_DOMAIN + "/v1/top/login";
          window.location.href = redirectUrl || toTopUrl;
        }
      })
      .catch(() => {
        window.sessionStorage.clear();
        // window.localStorage.clear();
        LocalStorage.removeAll();
        AuthApi.getLogout().catch((e) => {
          console.log(e);
        });
        auth.remove();
        if (this.ssoFlg) {
          // SSOログインの場合は行き止まりログアウトへ遷移
          window.location.href = "/logout/";
        } else {
          const toTopUrl = process.env.VUE_APP_API_DOMAIN + "/v1/top/login";
          window.location.href = redirectUrl || toTopUrl;
        }
      });
  }
}
